import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Textarea,
    Stack,
    VStack,
    Select,
    Link,
    Progress,
    useToast, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel,
} from '@chakra-ui/react';
import { FaCopy } from 'react-icons/fa';
import { getLogs, gerarOrcamento } from "../services/api";
import { useState, useEffect } from "react";
import Preloader from "../components/Preloader";
import PreloaderMini from "../components/PreloaderMini";
import { formatDistanceToNow, parse, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { FaSearch, FaDownload } from 'react-icons/fa';
import ScrollToTop from "../components/ScrollToTop";
import { useUsuarios, semBloqueados } from "../hooks/useUsuarios";

const Logs = () => {
    const [loading, setLoading] = useState(false);
    const [loadingMini, setLoadingMini] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);
    const [logs, setLogs] = useState([]);
    const [buscaBool, setBuscaBool] = useState(false);
    const [pagina, setPagina] = useState(1);
    const [ultimaPagina, setUltimaPagina] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [paginateFrom, setPaginateFrom] = useState(0);
    const [paginateTo, setPaginateTo] = useState(0);
    var consultaLogs = false;
    const toast = useToast()
    const hoje = new Date().toISOString().split('T')[0];

    var dataAtual = new Date();
    var ano = dataAtual.getFullYear();
    var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    var dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaInicial = `${ano}-${mes}-${dia}`;

    const [filtroId, setFiltroId] = useState("");
    const [filtroAcao, setFiltroAcao] = useState("");
    const [filtroUsuario, setFiltroUsuario] = useState("");
    const [filtroDataInicial, setFiltroDataInicial] = useState("");
    const [filtroDataFinal, setFiltroDataFinal] = useState("");
    const [filtroTipo, setFiltroTipo] = useState("usuario");
    const usuarios = useUsuarios();


    const handleGerarOrcamento = (codigoOrcamento) => {
        setLoading(true);
        try {
            (async () => {
                const requestData = {
                    codigo: codigoOrcamento
                };
                const response = await gerarOrcamento(requestData);
                if (response === false) {
                    toast({
                        title: `Erro ao baixar orçamento.`,
                        status: 'error',
                        isClosable: true,
                    })
                    setLoading(false);
                    return;
                }

                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                const now = new Date();
                const dateString = now.toISOString().replace(/[-:T.]/g, "");
                const fileName = `orcamento_taga_${dateString}.pdf`;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                setLoading(false);
            })();
        } catch {
            toast({
                title: `Erro ao baixar orçamento.`,
                status: 'error',
                isClosable: true,
            })
            setLoading(false);
            return false;
        }
    }

    useEffect(() => {
        if (consultaLogs == false) {
            consultarLogs(1);
            consultaLogs = true;
        }
    }, []);

    const handleAnterior = () => {
        let paginaAux = pagina - 1;
        if (paginaAux > 1) {
            setPagina(paginaAux);
        } else {
            setPagina(1);
        }
        consultarLogs(paginaAux);
    }

    const handleProxima = () => {
        let paginaAux = pagina + 1;
        setPagina(paginaAux);
        consultarLogs(paginaAux);
    }

    const handlePrimeira = () => {
        setPagina(1);
        consultarLogs(1);
    }

    const handleUltima = () => {
        setPagina(ultimaPagina);
        consultarLogs(ultimaPagina);
    }

    const handleChangeFiltroId = (event) => {
        setFiltroId(event.target.value);
    };

    const handleChangeFiltroAcao = (event) => {
        setFiltroAcao(event.target.value);
    };

    const handleChangeFiltroUsuario = (event) => {
        setFiltroUsuario(event.target.value);
    };

    const handleChangeFiltroDataInicial = (event) => {
        setFiltroDataInicial(event.target.value);
    };

    const handleChangeFiltroDataFinal = (event) => {
        setFiltroDataFinal(event.target.value);
    };

    const limparFiltros = () => {
        setFiltroId("");
        setFiltroAcao("");
        setFiltroUsuario("");
        setFiltroDataInicial("");
        setFiltroDataFinal("");
    };

    const handleTrocarAba = (tipo) => {
        setFiltroTipo(tipo);
        setFiltroUsuario("");
        setPagina(1);
        consultarLogsComTipo(tipo, 1);
    };

    function consultarLogsComTipo(tipo, paginaAux) {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                var consulta = "pagina=" + paginaAux + "&idAux=" + filtroId + "&acao=" + filtroAcao + "&usuario=&data_inicial=" + filtroDataInicial + "&data_final=" + filtroDataFinal + "&tipo=" + tipo;
                const responseLogs = await getLogs(consulta);
                if (responseLogs != false) {
                    setLogs(responseLogs.data);
                    setUltimaPagina(responseLogs.last_page);
                    setTotalRegistros(responseLogs.total);
                    setPaginateFrom(responseLogs.from);
                    setPaginateTo(responseLogs.to);
                    setBuscaBool(false);
                } else {
                    setLogs([]);
                    setBuscaBool(true);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        } catch {
            setLoadingLinear(false);
            setLoading(false);
        }
    }

    const handlePesquisar = () => {
        setPagina(1);
        consultarLogs(true);
    };

    function consultarLogs(paginaAux) {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                var consulta = "pagina=" + paginaAux + "&idAux=" + filtroId + "&acao=" + filtroAcao + "&usuario=" + filtroUsuario + "&data_inicial=" + filtroDataInicial + "&data_final=" + filtroDataFinal + "&tipo=" + filtroTipo;
                const responseLogs = await getLogs(consulta);
                if (responseLogs != false) {
                    setLogs(responseLogs.data);
                    setUltimaPagina(responseLogs.last_page)
                    setTotalRegistros(responseLogs.total);
                    setPaginateFrom(responseLogs.from);
                    setPaginateTo(responseLogs.to);
                    setBuscaBool(false);
                } else {
                    setLogs([]);
                    setBuscaBool(true);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }

    const formataCreatedAt = (data) => {
        const options = {
            timeZone: 'America/Sao_Paulo',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return new Date(data).toLocaleString('pt-BR', options);
    }

    const getImgUser = (usuario_id) => {
        var img = "taga_logo.jpg";
        if (usuario_id == 3) {
            img = "/gabriel_logo.webp";
        } else if (usuario_id == 5) {
            img = "/tilio_logo.webp";
        } else if (usuario_id == 6) {
            img = "/riccioppo_logo.webp";
        } else if (usuario_id == 7) {
            img = "/user.png";
        } else if (usuario_id == 8) {
            img = "/gabriel_valiente_logo.webp";
        } else if (usuario_id == 9) {
            img = "/emerson_vendedor_logo.webp";
        } else if (usuario_id == 10) {
            img = "/analuiza_logo.webp";
        }

        return img;
    };

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box textAlign="center" fontSize="xl" py={10} bg="white" minH="100vh">
                <Box textAlign="center" ml={4} mb={0} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        LOGS
                    </Text>
                </Box>
                <Box mx={{ base: 1, md: 12, lg: 20 }} mt={0} boxShadow='md' borderRadius="lg" px={0} mb={"10"} pb={2}>
                    <HStack spacing={3} pt={4} px={4}>
                        <Button
                            onClick={() => handleTrocarAba("usuario")}
                            variant={filtroTipo === "usuario" ? "solid" : "ghost"}
                            bg={filtroTipo === "usuario" ? "orange.100" : "transparent"}
                            color={filtroTipo === "usuario" ? "orange.800" : "gray.600"}
                            colorScheme="orange"
                            boxShadow={filtroTipo === "usuario" ? "md" : "none"}
                            _hover={filtroTipo === "usuario" ? { bg: "orange.200" } : {}}
                            borderRadius="lg"
                            size="md"
                        >
                            Logs Usuários
                        </Button>
                        <Button
                            onClick={() => handleTrocarAba("sistema")}
                            variant={filtroTipo === "sistema" ? "solid" : "ghost"}
                            bg={filtroTipo === "sistema" ? "gray.200" : "transparent"}
                            color={filtroTipo === "sistema" ? "gray.800" : "gray.600"}
                            colorScheme="gray"
                            boxShadow={filtroTipo === "sistema" ? "md" : "none"}
                            _hover={filtroTipo === "sistema" ? { bg: "gray.300" } : {}}
                            borderRadius="lg"
                            size="md"
                        >
                            Logs Sistema
                        </Button>
                    </HStack>
                    <Box mb={16}>
                        <Text fontSize={"16px"} textAlign="start" ml={4} mt={12} color={"#F68633"} fontWeight={"bold"}>
                            FILTROS
                        </Text>
                        <Flex align={"center"} justifyContent={"center"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    ID
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder=""
                                    w={{ base: "300px", md: "150px", lg: "150px", xl: "180px" }}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroId}
                                    onChange={handleChangeFiltroId}
                                />
                            </Box>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    AÇÃO
                                </Text>
                                <Select
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    ml={2}
                                    value={filtroAcao}
                                    onChange={handleChangeFiltroAcao}
                                    boxShadow='lg'
                                >
                                    <option value="" selected disabled>Selecione</option>
                                    <option value="0">Todos</option>
                                    <optgroup label="Vendas">
                                        <option value="Cotação">Cotação</option>
                                        <option value="Furo de estoque">Furo de estoque</option>
                                        <option value="Status TAGA">Status TAGA</option>
                                        <option value="Status Venda">Status Venda</option>
                                        <option value="Marcador Venda">Marcador Venda</option>
                                        <option value="Observações TAGA">Observações TAGA</option>
                                        <option value="Apagou a Observação">Apagou a Observação</option>
                                        <option value="Atribuição de Venda">Atribuição de Venda</option>
                                        <option value="Atualizar Cliente da Venda">Atualizar Cliente da Venda</option>
                                        <option value="Editar Prazo de Envio">Editar Prazo de Envio</option>
                                        <option value="Enviar Mensagem Venda">Enviar Mensagem Venda</option>
                                        <option value="Venda Manual">Venda Manual</option>
                                        <option value="Webhook Ecommerce">Webhook Ecommerce</option>
                                        <option value="Cancelar Item Venda">Cancelar Item Venda</option>
                                        <option value="Desfazer Cancelamento Item">Desfazer Cancelamento Item</option>
                                        <option value="Reembolso Mercado Pago (item)">Reembolso Mercado Pago (item)</option>
                                    </optgroup>
                                    <optgroup label="Despacho / Conferência">
                                        <option value="Salvar Conferência de Despacho">Salvar Conferência de Despacho</option>
                                        <option value="Automação Produto Diferente">Automação Produto Diferente</option>
                                        <option value="Reverter Conferência de Despacho">Reverter Conferência de Despacho</option>
                                        <option value="Concluir Embalagem">Concluir Embalagem</option>
                                        <option value="Reverter Embalagem">Reverter Embalagem</option>
                                        <option value="Processar Venda para Expedição">Processar Venda para Expedição</option>
                                        <option value="Marcar Envio Externo">Marcar Envio Externo</option>
                                        <option value="Desmarcar Envio Externo">Desmarcar Envio Externo</option>
                                        <option value="Obter Conteúdo ZPL">Obter Conteúdo ZPL</option>
                                        <option value="Imprimir Etiquetas Unificado">Imprimir Etiquetas Unificado</option>
                                    </optgroup>
                                    <optgroup label="Mercado Livre">
                                        <option value="Imprimir Etiqueta">Imprimir Etiqueta</option>
                                        <option value="Emitir Nota Fiscal Mercado Livre">Emitir Nota Fiscal Mercado Livre</option>
                                        <option value="Emitir Nota Fiscal via API Interna">Emitir Nota Fiscal via API Interna</option>
                                        <option value="Sincronizar NFe Existente">Sincronizar NFe Existente</option>
                                        <option value="Sincronizar NFe Existente (API Interna)">Sincronizar NFe Existente (API Interna)</option>
                                        <option value="Baixar XML/DANFE NFe">Baixar XML/DANFE NFe</option>
                                        <option value="Responder Pergunta">Responder Pergunta</option>
                                        <option value="Responder Denúncia ML">Responder Denúncia ML</option>
                                    </optgroup>
                                    <optgroup label="Devoluções">
                                        <option value="Sync manual de devolução">Sync manual de devolução</option>
                                        <option value="Devolução Finalizada Manualmente">Devolução Finalizada Manualmente</option>
                                        <option value="Devolução Finalizada Automaticamente">Devolução Finalizada Automaticamente</option>
                                        <option value="Devolução Incluída no Estoque">Devolução Incluída no Estoque</option>
                                        <option value="Devolução Revertida do Estoque">Devolução Revertida do Estoque</option>
                                        <option value="Revisão OK (chegou como esperado)">Revisão OK</option>
                                        <option value="Revisão com falha">Revisão com falha</option>
                                        <option value="Upload de anexo para revisão">Upload de anexo para revisão</option>
                                        <option value="Re-upload de anexo existente">Re-upload de anexo existente</option>
                                        <option value="Consulta de custo de envio">Consulta de custo de envio</option>
                                        <option value="Atualizando recebimento de Devolução">Atualizando recebimento de Devolução</option>
                                        <option value="Atualizando avaria de Devolução">Atualizando avaria de Devolução</option>
                                        <option value="Anexando arquivos à devolução">Anexando arquivos à devolução</option>
                                        <option value="Atualizando pré-análise da devolução">Atualizando pré-análise da devolução</option>
                                        <option value="Imagem Corrigida na Devolução">Imagem Corrigida na Devolução</option>
                                        <option value="Financeiro da Devolução Recalculado">Financeiro da Devolução Recalculado</option>
                                        <option value="Devolução de Item Venda">Devolução de Item Venda</option>
                                    </optgroup>
                                    <optgroup label="Melhor Envio">
                                        <option value="Criar Envio Melhor Envio">Criar Envio Melhor Envio</option>
                                        <option value="Checkout Melhor Envio">Checkout Melhor Envio</option>
                                        <option value="Gerar Etiqueta Melhor Envio">Gerar Etiqueta Melhor Envio</option>
                                        <option value="Rastrear Melhor Envio">Rastrear Melhor Envio</option>
                                        <option value="Pagar Etiqueta do Carrinho">Pagar Etiqueta do Carrinho</option>
                                        <option value="Processar Envio Completo Melhor Envio">Processar Envio Completo Melhor Envio</option>
                                        <option value="Adicionar ao Carrinho ME">Adicionar ao Carrinho ME</option>
                                        <option value="Remover do Carrinho ME">Remover do Carrinho ME</option>
                                        <option value="Cancelar Etiqueta ME">Cancelar Etiqueta ME</option>
                                        <option value="Adicionar Saldo ME">Adicionar Saldo ME</option>
                                    </optgroup>
                                    <optgroup label="Notas Fiscais">
                                        <option value="Emitir Nota Fiscal API Externa">Emitir Nota Fiscal API Externa</option>
                                        <option value="Sincronizar XML NF-e">Sincronizar XML NF-e</option>
                                        <option value="Exportar XML NF-e">Exportar XML NF-e</option>
                                        <option value="Exportar XML NF-e Recusada">Exportar XML NF-e Recusada</option>
                                    </optgroup>
                                    <optgroup label="NF-e de Devolução do Cliente">
                                        <option value="NF-e de devolução emitida">NF-e de devolução emitida</option>
                                        <option value="NF-e de devolução bloqueada">NF-e de devolução bloqueada</option>
                                        <option value="NF-e de devolução com erro">NF-e de devolução com erro</option>
                                        <option value="NF-e de devolução cancelada">NF-e de devolução cancelada</option>
                                        <option value="NF-e de devolução: nota do cliente">NF-e de devolução: nota do cliente</option>
                                        <option value="Gerar NF-e de devolução sob demanda">Gerar NF-e de devolução sob demanda</option>
                                        <option value="Gerar NF-e de devolução da venda">Gerar NF-e de devolução da venda</option>
                                        <option value="Gerar NF-e de devolução recusado">Gerar NF-e de devolução recusado</option>
                                        <option value="Marcações da NF-e de devolução">Marcações da NF-e de devolução</option>
                                        <option value="Marcações da NF-e de devolução recusadas">Marcações da NF-e de devolução recusadas</option>
                                        <option value="Reprocessar NF-e de devolução">Reprocessar NF-e de devolução</option>
                                        <option value="Nota do cliente confirmada">Nota do cliente confirmada</option>
                                        <option value="Notas do cliente descartadas">Notas do cliente descartadas</option>
                                        <option value="Configuracao da NF-e de devolucao">Configuração da NF-e de devolução</option>
                                        <option value="Fila de vendas canceladas: atualizacao">Fila de cancelados: atualização</option>
                                        <option value="Fila de vendas canceladas: decisao">Fila de cancelados: decisão</option>
                                        <option value="Fila de vendas canceladas: decisao recusada">Fila de cancelados: decisão recusada</option>
                                        <option value="Fila de vendas canceladas: consulta SEFAZ">Fila de cancelados: consulta SEFAZ</option>
                                        <option value="Fila de vendas canceladas: consulta SEFAZ falhou">Fila de cancelados: consulta SEFAZ falhou</option>
                                        <option value="Sincronizar NF-e de devolução do ML">Sincronizar NF-e de devolução do ML</option>
                                    </optgroup>
                                    <optgroup label="Usuários / Admin">
                                        <option value="Criar usuário">Criar usuário</option>
                                        <option value="Atualizar usuário">Atualizar usuário</option>
                                        <option value="Atualizar permissões">Atualizar permissões</option>
                                        <option value="Atualizar Configurações Gerais">Atualizar Configurações Gerais</option>
                                    </optgroup>
                                    <optgroup label="Listas de Desconto">
                                        <option value="Criar Lista de Desconto">Criar Lista de Desconto</option>
                                        <option value="Atualizar Lista de Desconto">Atualizar Lista de Desconto</option>
                                        <option value="Atualizar Status Lista de Desconto">Atualizar Status Lista de Desconto</option>
                                        <option value="Excluir Lista de Desconto">Excluir Lista de Desconto</option>
                                        <option value="Excluir Item de Lista de Desconto">Excluir Item de Lista de Desconto</option>
                                    </optgroup>
                                    <optgroup label="DRE">
                                        <option value="Criar Categoria DRE">Criar Categoria DRE</option>
                                        <option value="Atualizar Categoria DRE">Atualizar Categoria DRE</option>
                                        <option value="Excluir Categoria DRE">Excluir Categoria DRE</option>
                                        <option value="Criar Custo DRE">Criar Custo DRE</option>
                                        <option value="Atualizar Custo DRE">Atualizar Custo DRE</option>
                                        <option value="Desativar Custo Fixo DRE">Desativar Custo Fixo DRE</option>
                                        <option value="Excluir Custo Variável DRE">Excluir Custo Variável DRE</option>
                                        <option value="Definir CMV Manual Furo Estoque">Definir CMV Manual Furo Estoque</option>
                                    </optgroup>
                                    <optgroup label="Listas de Compra">
                                        <option value="Criar Lista de Compra">Criar Lista de Compra</option>
                                        <option value="Aprovar Resposta Fornecedor">Aprovar Resposta Fornecedor</option>
                                        <option value="Rejeitar Resposta Fornecedor">Rejeitar Resposta Fornecedor</option>
                                        <option value="Finalizar Aprovação Lista de Compra">Finalizar Aprovação Lista de Compra</option>
                                        <option value="Atualizar Status Envio Lista de Compra">Atualizar Status Envio Lista de Compra</option>
                                        <option value="Cancelar Lista de Compra">Cancelar Lista de Compra</option>
                                        <option value="Enviar Lista de Compra via WhatsApp">Enviar Lista de Compra via WhatsApp</option>
                                    </optgroup>
                                    <optgroup label="Poli (Atendimento)">
                                        <option value="Criar Contato Poli">Criar Contato Poli</option>
                                        <option value="Atualizar Contato Poli">Atualizar Contato Poli</option>
                                        <option value="Excluir Contato Poli">Excluir Contato Poli</option>
                                        <option value="Abrir Contato Poli">Abrir Contato Poli</option>
                                        <option value="Fechar Contato Poli">Fechar Contato Poli</option>
                                        <option value="Redirecionar Contato Poli">Redirecionar Contato Poli</option>
                                    </optgroup>
                                    <optgroup label="Produtos">
                                        <option value="Bloqueio/Desbloqueio de Produto">Bloqueio/Desbloqueio de Produto</option>
                                    </optgroup>
                                    <optgroup label="Estoque">
                                        <option value="Revisão de Estoque">Revisão de Estoque</option>
                                        <option value="Imagem Corrigida na Revisão de Estoque">Imagem Corrigida na Revisão de Estoque</option>
                                        <option value="Transferência de Estoque">Transferência de Estoque</option>
                                        <option value="Transferência de Estoque Recusada">Transferência de Estoque Recusada</option>
                                        <option value="Exportar Movimentação de Estoque">Exportar Movimentação de Estoque</option>
                                        <option value="Exportar Movimentação de Estoque Recusada">Exportar Movimentação de Estoque Recusada</option>
                                    </optgroup>
                                    <optgroup label="Melhor Envio (reversa)">
                                        <option value="Sincronizar Reversas Melhor Envio">Sincronizar Reversas Melhor Envio</option>
                                        <option value="Sincronizar Reversas Melhor Envio (falha)">Sincronizar Reversas Melhor Envio (falha)</option>
                                    </optgroup>
                                    <optgroup label="Outros">
                                        <option value="Gerando Orçamento">Geração de Orçamento</option>
                                    </optgroup>
                                </Select>
                            </Box>
                            {filtroTipo === "usuario" && (
                                <Box mr={4} >
                                    <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                        USUÁRIO
                                    </Text>
                                    <Select
                                        w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                        ml={2}
                                        value={filtroUsuario}
                                        onChange={handleChangeFiltroUsuario}
                                        boxShadow='lg'
                                    >
                                        <option value="" selected disabled>Selecione</option>
                                        <option value="0">Todos</option>
                                        {semBloqueados(usuarios).map((usuario) => (
                                            <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                        ))}
                                    </Select>
                                </Box>
                            )}
                            <Box mr={4}>
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    DATA INCIAL
                                </Text>
                                <Input
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    placeholder="Selecione a data inicial"
                                    type="date"
                                    max={hoje}
                                    value={filtroDataInicial}
                                    onChange={handleChangeFiltroDataInicial}
                                    boxShadow='lg'
                                />
                            </Box>
                            <Box mr={4}>
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    DATA FINAL
                                </Text>
                                <Input
                                    w={{ base: "300px", md: "150px", lg: "180px", xl: "180px" }}
                                    placeholder="Selecione a data final"
                                    type="date"
                                    max={hoje}
                                    value={filtroDataFinal}
                                    onChange={handleChangeFiltroDataFinal}
                                    boxShadow='lg'
                                />
                            </Box>
                            <Box>
                                <Button
                                    mt={6}
                                    bg={"#01695E"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={handlePesquisar}
                                    boxShadow='lg'
                                >
                                    <FaSearch fontSize='12px' boxShadow='lg' />
                                </Button>
                                <Button
                                    mt={6}
                                    ml={2}
                                    bg={"#FF0000"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={limparFiltros}
                                    boxShadow='lg'
                                >
                                    X
                                </Button>
                            </Box>
                        </Flex>
                    </Box>
                    {
                        buscaBool && !loading &&
                        <Alert status='warning'>
                            <AlertIcon />
                            <AlertTitle>Nenhum registro encontrado!</AlertTitle>
                        </Alert>
                    }
                    <Box overflowX="auto" mt={10} mx={{ base: "0", sm: "2", md: "6" }}>
                        <Table>
                            <Thead bg={"#bfbdbd"}>
                                <Tr>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E"></Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Usuário</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">ID</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Ação</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Mensagem</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Data</Th>
                                </Tr>
                            </Thead>
                            <Tbody color={"black"}>
                                {logs && !loading && logs.map((log) => (
                                    <Tr key={log.id}
                                        px={2}
                                        _hover={{
                                            background: "#dbdbdb",
                                            transition: "background 0.4s ease-in"
                                        }}
                                        borderColor="green"
                                    >
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "16px" }} textAlign={"center"}>{
                                            <Image
                                                boxShadow='lg'
                                                borderRadius="50%"
                                                src={getImgUser(log.user_id)}
                                                alt={"imagem_user"}
                                                maxW={{ base: "30px", md: "30px", lg: "30px" }}
                                                maxH="30px"
                                            />
                                        }</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "14px" }} textAlign={"center"}>{log.user_name}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "14px", sm: "14px", md: "14px", lg: "16px", xl: "14px" }} textAlign={"center"} fontWeight={"bold"}>{log.id_aux}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{log.acao}</Td>
                                        <Td
                                            px={1}
                                            borderColor={"white"}
                                            fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }}
                                            textAlign={"center"}
                                        >
                                            {log.acao === "Gerando Orçamento"
                                                ? (
                                                    <>
                                                        <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                                            {log.mensagem}
                                                            <Box ml={2}
                                                                style={{ cursor: 'pointer' }}
                                                                _hover={{ color: "blue.500", transform: "scale(1.1)" }}
                                                                onClick={() => handleGerarOrcamento(log.id_aux)}
                                                            >
                                                                <FaDownload
                                                                />
                                                            </Box>
                                                        </Flex>

                                                    </>
                                                )
                                                : log.mensagem
                                            }
                                        </Td>


                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>{formataCreatedAt(log.created_at)}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                    <Flex justifyContent={"center"} mt={6}>
                        <Flex flexDirection={"column"}>
                            <Text fontSize={'10px'} fontWeight={"bold"}>
                                Mostrando {logs ? logs.length : 0} de {totalRegistros} registros do {paginateFrom} ao {paginateTo}
                            </Text>
                            <Flex flexDirection={"row"}>
                                {
                                    pagina != 1 ? (
                                        <Button
                                            onClick={() => handlePrimeira()}
                                        >
                                            {"<<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled>
                                                {"<<"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina > 1 ? (
                                        <Button
                                            onClick={() => handleAnterior()}
                                        >
                                            {"<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {"<"}
                                            </Button>
                                        )
                                }
                                <Button disabled>{pagina}</Button>
                                {

                                    pagina < ultimaPagina ? (
                                        <Button
                                            onClick={() => handleProxima()}
                                        >
                                            {">"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina != ultimaPagina ? (
                                        <Button
                                            onClick={() => handleUltima()}
                                        >
                                            {">>"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">>"}
                                            </Button>
                                        )
                                }

                            </Flex>
                        </Flex>
                    </Flex>
                    {loadingLinear && <Progress mb={0} size='xs' isIndeterminate colorScheme="orange" />}
                </Box>
            </Box>
        </>
    );
};

export default Logs;
